import React from "react";
import { FileObject, ResolvedFile } from "@citychallenge/common";
import { ImageSource } from "./image-source";

export class ResourceContextImpl {
  public available = false;
  public resolveFile(_fileObject: FileObject): ResolvedFile;
  public resolveFile(
    _fileObject: FileObject | undefined
  ): ResolvedFile | undefined;
  public resolveFile(
    _fileObject: FileObject | undefined
  ): ResolvedFile | undefined {
    throw new Error(
      "'ResourceContext.resolveFile was called without a ResourceManager being present in the tree!"
    );
  }

  public resolveImageProp(
    _imageProp?: FileObject | ImageSource
  ): ImageSource | undefined {
    throw new Error(
      "'ResourceContext.resolveImageProp was called without a ResourceManager being present in the tree!"
    );
  }
}
export const ResourceContext = React.createContext(new ResourceContextImpl());
